import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import About from './pages/About';
import Partners from './pages/Partners';
import Resources from './pages/Resources';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Disclaimer from './pages/Disclaimer';
import Careers from './pages/Careers';
import Sitemap from './pages/Sitemap';
import FreeAssessment from './pages/FreeAssessment';
import TaxScorecard from './pages/TaxScorecard';
import ScheduleCall from './pages/ScheduleCall';
import SuccessStories from './pages/SuccessStories';
import ForAdvisors from './pages/ForAdvisors';
import ThankYou from './pages/ThankYou';
import NotFound from './pages/NotFound';
import FunnelEditor from './pages/FunnelEditor';

/**
 * Layout wrapper for pages with Navbar and Footer
 */
function MainLayout({ children }) {
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Editor route - standalone, no navbar/footer */}
        <Route path="/editor/:funnelId/:pageId" element={<FunnelEditor />} />

        {/* Main site routes with navbar/footer */}
        <Route path="/" element={<MainLayout><Home /></MainLayout>} />
        <Route path="/services" element={<MainLayout><Services /></MainLayout>} />
        <Route path="/services/:slug" element={<MainLayout><ServiceDetail /></MainLayout>} />
        <Route path="/about" element={<MainLayout><About /></MainLayout>} />
        <Route path="/partners" element={<MainLayout><Partners /></MainLayout>} />
        <Route path="/resources" element={<MainLayout><Resources /></MainLayout>} />
        <Route path="/blog" element={<MainLayout><Blog /></MainLayout>} />
        <Route path="/blog/:slug" element={<MainLayout><BlogPost /></MainLayout>} />
        <Route path="/contact" element={<MainLayout><Contact /></MainLayout>} />
        <Route path="/careers" element={<MainLayout><Careers /></MainLayout>} />
        <Route path="/sitemap" element={<MainLayout><Sitemap /></MainLayout>} />
        <Route path="/free-assessment" element={<MainLayout><FreeAssessment /></MainLayout>} />
        <Route path="/tax-scorecard" element={<MainLayout><TaxScorecard /></MainLayout>} />
        <Route path="/schedule-call" element={<MainLayout><ScheduleCall /></MainLayout>} />
        <Route path="/success-stories" element={<MainLayout><SuccessStories /></MainLayout>} />
        <Route path="/for-advisors" element={<MainLayout><ForAdvisors /></MainLayout>} />
        <Route path="/privacy" element={<MainLayout><Privacy /></MainLayout>} />
        <Route path="/terms" element={<MainLayout><Terms /></MainLayout>} />
        <Route path="/disclaimer" element={<MainLayout><Disclaimer /></MainLayout>} />
        <Route path="/thank-you" element={<MainLayout><ThankYou /></MainLayout>} />
        <Route path="*" element={<MainLayout><NotFound /></MainLayout>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
